// Components
const ClientHeader = () =>
    import(
        /* webpackPrefetch: true, webpackChunkName: "client-header" */ "@/app/views/client-view/_shared/client-header/client-header.vue"
    );
const TheFooter = () =>
    import(
        /* webpackPrefetch: true, webpackChunkName: "the-footer" */ "@/app/views/main-view/_shared/the-footer/the-footer.vue"
    );
const BreederBioDetailsPage = () =>
    import(
        /* webpackPrefetch: true, webpackChunkName: "breeder-bio-details-page" */ "@/app/views/client-view/breeder-bio-page/components/breeder-bio-details-page/breeder-bio-details-page.vue"
    );

// Mixins
import { googleTagManagerMixins } from "@/app/mixins/utils/google-tag-manager-mixins";

export default {
    name: "BreederBioDetailsContainer",
    mixins: [googleTagManagerMixins],
    components: {
        ClientHeader,
        TheFooter,
        BreederBioDetailsPage,
    },
    computed: {
        isNativeApp() {
            return this.$store.getters.getIsNativeApp;
        },
    },
    data() {
        return {
            hasLatitudePay: false,
            showMainLogo: true,
        };
    },
};
